// THIS FILE IS GENERATED by packages/console-api-types/scripts/gen-operations.ts. Do not edit.
// Run `npm run generate -w @akashnetwork/console-api-types` to regenerate.

export const operations = {
  v1: {
    getWalletSettings: { path: "/v1/wallet-settings", method: "get", operationId: "getWalletSettings", pathParams: [], queryParams: [], hasBody: false },
    createWalletSettings: { path: "/v1/wallet-settings", method: "post", operationId: "createWalletSettings", pathParams: [], queryParams: [], hasBody: true },
    updateWalletSettings: { path: "/v1/wallet-settings", method: "put", operationId: "updateWalletSettings", pathParams: [], queryParams: [], hasBody: true },
    deleteWalletSettings: {
      path: "/v1/wallet-settings",
      method: "delete",
      operationId: "deleteWalletSettings",
      pathParams: [],
      queryParams: [],
      hasBody: false
    },
    listStripePrices: { path: "/v1/stripe/prices", method: "get", operationId: "listStripePrices", pathParams: [], queryParams: [], hasBody: false },
    applyStripeCoupon: { path: "/v1/stripe/coupons/apply", method: "post", operationId: "applyStripeCoupon", pathParams: [], queryParams: [], hasBody: true },
    createSetupIntent: {
      path: "/v1/stripe/payment-methods/setup",
      method: "post",
      operationId: "createSetupIntent",
      pathParams: [],
      queryParams: ["cardOnly"],
      hasBody: false
    },
    setDefaultPaymentMethod: {
      path: "/v1/stripe/payment-methods/default",
      method: "post",
      operationId: "setDefaultPaymentMethod",
      pathParams: [],
      queryParams: [],
      hasBody: true
    },
    getDefaultPaymentMethod: {
      path: "/v1/stripe/payment-methods/default",
      method: "get",
      operationId: "getDefaultPaymentMethod",
      pathParams: [],
      queryParams: [],
      hasBody: false
    },
    listPaymentMethods: {
      path: "/v1/stripe/payment-methods",
      method: "get",
      operationId: "listPaymentMethods",
      pathParams: [],
      queryParams: [],
      hasBody: false
    },
    deletePaymentMethod: {
      path: "/v1/stripe/payment-methods/{paymentMethodId}",
      method: "delete",
      operationId: "deletePaymentMethod",
      pathParams: ["paymentMethodId"],
      queryParams: [],
      hasBody: false
    },
    validatePaymentMethod: {
      path: "/v1/stripe/payment-methods/validate",
      method: "post",
      operationId: "validatePaymentMethod",
      pathParams: [],
      queryParams: [],
      hasBody: true
    },
    confirmStripeTransaction: {
      path: "/v1/stripe/transactions/confirm",
      method: "post",
      operationId: "confirmStripeTransaction",
      pathParams: [],
      queryParams: [],
      hasBody: true
    },
    listStripeTransactions: {
      path: "/v1/stripe/transactions",
      method: "get",
      operationId: "listStripeTransactions",
      pathParams: [],
      queryParams: ["limit", "offset", "startDate", "endDate"],
      hasBody: false
    },
    exportStripeTransactions: {
      path: "/v1/stripe/transactions/export",
      method: "get",
      operationId: "exportStripeTransactions",
      pathParams: [],
      queryParams: ["timezone", "startDate", "endDate"],
      hasBody: false
    },
    createStripeTransactionInvoice: {
      path: "/v1/stripe/transactions/{id}/invoice",
      method: "post",
      operationId: "createStripeTransactionInvoice",
      pathParams: ["id"],
      queryParams: [],
      hasBody: false
    },
    getBillingDetails: { path: "/v1/billing-details", method: "get", operationId: "getBillingDetails", pathParams: [], queryParams: [], hasBody: false },
    updateBillingDetails: { path: "/v1/billing-details", method: "put", operationId: "updateBillingDetails", pathParams: [], queryParams: [], hasBody: true },
    getFirstPurchaseBonus: {
      path: "/v1/stripe/first-purchase-bonus",
      method: "get",
      operationId: "getFirstPurchaseBonus",
      pathParams: [],
      queryParams: [],
      hasBody: false
    },
    acceptFairUsePolicy: {
      path: "/v1/user/acceptFairUsePolicy",
      method: "post",
      operationId: "acceptFairUsePolicy",
      pathParams: [],
      queryParams: [],
      hasBody: false
    },
    markGetStartedDismissed: {
      path: "/v1/user/markGetStartedDismissed",
      method: "post",
      operationId: "markGetStartedDismissed",
      pathParams: [],
      queryParams: [],
      hasBody: false
    },
    markAgentSetupCopied: {
      path: "/v1/user/markAgentSetupCopied",
      method: "post",
      operationId: "markAgentSetupCopied",
      pathParams: [],
      queryParams: [],
      hasBody: false
    },
    markGithubStarPrompted: {
      path: "/v1/user/markGithubStarPrompted",
      method: "post",
      operationId: "markGithubStarPrompted",
      pathParams: [],
      queryParams: [],
      hasBody: false
    },
    createAccountDeletionRequest: {
      path: "/v1/user/me/initiate-deletion",
      method: "post",
      operationId: "createAccountDeletionRequest",
      pathParams: [],
      queryParams: [],
      hasBody: true
    },
    getAccountDeletionEligibility: {
      path: "/v1/user/me/deletion-eligibility",
      method: "get",
      operationId: "getAccountDeletionEligibility",
      pathParams: [],
      queryParams: [],
      hasBody: false
    },
    confirmAccountDeletion: {
      path: "/v1/user/me/confirm-deletion",
      method: "post",
      operationId: "confirmAccountDeletion",
      pathParams: [],
      queryParams: [],
      hasBody: true
    },
    createProductUpdateUnsubscription: {
      path: "/v1/product-update-unsubscriptions",
      method: "post",
      operationId: "createProductUpdateUnsubscription",
      pathParams: [],
      queryParams: ["token"],
      hasBody: false
    },
    getDeploymentFundingConfig: {
      path: "/v1/deployment-funding-config",
      method: "get",
      operationId: "getDeploymentFundingConfig",
      pathParams: [],
      queryParams: [],
      hasBody: false
    },
    getDeployment: { path: "/v1/deployments/{dseq}", method: "get", operationId: "getDeployment", pathParams: ["dseq"], queryParams: [], hasBody: false },
    closeDeployment: {
      path: "/v1/deployments/{dseq}",
      method: "delete",
      operationId: "closeDeployment",
      pathParams: ["dseq"],
      queryParams: ["async", "batchId"],
      hasBody: false
    },
    updateDeployment: { path: "/v1/deployments/{dseq}", method: "put", operationId: "updateDeployment", pathParams: ["dseq"], queryParams: [], hasBody: true },
    patchDeployment: {
      path: "/v1/deployments/{dseq}",
      method: "patch",
      operationId: "patchDeployment",
      pathParams: ["dseq"],
      queryParams: ["async"],
      hasBody: true
    },
    getDeploymentInfo: {
      path: "/v1/deployments/{dseq}/info",
      method: "get",
      operationId: "getDeploymentInfo",
      pathParams: ["dseq"],
      queryParams: [],
      hasBody: false
    },
    listDeploymentNames: {
      path: "/v1/deployment-names",
      method: "get",
      operationId: "listDeploymentNames",
      pathParams: [],
      queryParams: ["dseq"],
      hasBody: false
    },
    createDeployment: {
      path: "/v1/deployments",
      method: "post",
      operationId: "createDeployment",
      pathParams: [],
      queryParams: ["async", "autoLease"],
      hasBody: true
    },
    listDeployments: {
      path: "/v1/deployments",
      method: "get",
      operationId: "listDeployments",
      pathParams: [],
      queryParams: ["state", "reverse", "search", "skip", "limit", "projectId"],
      hasBody: false
    },
    depositDeployment: { path: "/v1/deposit-deployment", method: "post", operationId: "depositDeployment", pathParams: [], queryParams: [], hasBody: true },
    createDeploymentDefinition: {
      path: "/v1/deployments/{dseq}/definition",
      method: "post",
      operationId: "createDeploymentDefinition",
      pathParams: ["dseq"],
      queryParams: [],
      hasBody: true
    },
    getSpendRate: { path: "/v1/spend-rate", method: "get", operationId: "getSpendRate", pathParams: [], queryParams: [], hasBody: false },
    updateDeploymentProject: {
      path: "/v1/deployments/{dseq}/project",
      method: "patch",
      operationId: "updateDeploymentProject",
      pathParams: ["dseq"],
      queryParams: [],
      hasBody: true
    },
    getDeploymentLocation: {
      path: "/v1/deployment-locations/{dseq}",
      method: "get",
      operationId: "getDeploymentLocation",
      pathParams: ["dseq"],
      queryParams: [],
      hasBody: false
    },
    getSDLSecretsContext: {
      path: "/v1/sdl-secrets-context",
      method: "get",
      operationId: "getSDLSecretsContext",
      pathParams: [],
      queryParams: [],
      hasBody: false
    },
    createLease: { path: "/v1/leases", method: "post", operationId: "createLease", pathParams: [], queryParams: ["async"], hasBody: true },
    listLeases: {
      path: "/v1/leases",
      method: "get",
      operationId: "listLeases",
      pathParams: [],
      queryParams: ["dseq", "provider", "state", "limit"],
      hasBody: false
    },
    listApiKeys: { path: "/v1/api-keys", method: "get", operationId: "listApiKeys", pathParams: [], queryParams: [], hasBody: false },
    listBids: { path: "/v1/bids", method: "get", operationId: "listBids", pathParams: [], queryParams: ["dseq"], hasBody: false },
    getWalletBalances: { path: "/v1/wallet-balances", method: "get", operationId: "getWalletBalances", pathParams: [], queryParams: [], hasBody: false },
    listFeeAllowances: { path: "/v1/fee-allowances", method: "get", operationId: "listFeeAllowances", pathParams: [], queryParams: [], hasBody: false },
    listProviders: { path: "/v1/providers", method: "get", operationId: "listProviders", pathParams: [], queryParams: ["scope", "addresses"], hasBody: false },
    getBlock: { path: "/v1/blocks/{height}", method: "get", operationId: "getBlock", pathParams: ["height"], queryParams: [], hasBody: false },
    listGpuPrices: { path: "/v1/gpu-prices", method: "get", operationId: "listGpuPrices", pathParams: [], queryParams: [], hasBody: false },
    listTrialGpuAvailability: {
      path: "/v1/trial-gpu-availability",
      method: "get",
      operationId: "listTrialGpuAvailability",
      pathParams: [],
      queryParams: [],
      hasBody: false
    },
    screenProviders: { path: "/v1/bid-screening", method: "post", operationId: "screenProviders", pathParams: [], queryParams: [], hasBody: true },
    listPlacementOptions: {
      path: "/v1/placement-options",
      method: "get",
      operationId: "listPlacementOptions",
      pathParams: [],
      queryParams: [],
      hasBody: false
    },
    validateConfidentialComputeAttestation: {
      path: "/v1/confidential-compute/attestation/validate",
      method: "post",
      operationId: "validateConfidentialComputeAttestation",
      pathParams: [],
      queryParams: [],
      hasBody: true
    },
    createHardwareRequest: {
      path: "/v1/hardware-requests",
      method: "post",
      operationId: "createHardwareRequest",
      pathParams: [],
      queryParams: [],
      hasBody: true
    },
    listHardwareRequests: {
      path: "/v1/hardware-requests",
      method: "get",
      operationId: "listHardwareRequests",
      pathParams: [],
      queryParams: [],
      hasBody: false
    },
    listHardwareRequestOffers: {
      path: "/v1/hardware-requests/{id}/offers",
      method: "get",
      operationId: "listHardwareRequestOffers",
      pathParams: ["id"],
      queryParams: [],
      hasBody: false
    },
    withdrawHardwareRequest: {
      path: "/v1/hardware-requests/{id}/withdraw",
      method: "post",
      operationId: "withdrawHardwareRequest",
      pathParams: ["id"],
      queryParams: [],
      hasBody: false
    },
    acceptHardwareRequestOffer: {
      path: "/v1/hardware-requests/{id}/offers/{offerId}/accept",
      method: "post",
      operationId: "acceptHardwareRequestOffer",
      pathParams: ["id", "offerId"],
      queryParams: [],
      hasBody: false
    },
    declineHardwareRequestOffer: {
      path: "/v1/hardware-requests/{id}/offers/{offerId}/decline",
      method: "post",
      operationId: "declineHardwareRequestOffer",
      pathParams: ["id", "offerId"],
      queryParams: [],
      hasBody: false
    },
    requestHardwareRequestOfferApproval: {
      path: "/v1/hardware-requests/{id}/offers/{offerId}/request-approval",
      method: "post",
      operationId: "requestHardwareRequestOfferApproval",
      pathParams: ["id", "offerId"],
      queryParams: [],
      hasBody: false
    },
    createNotificationAddressConfirmation: {
      path: "/v1/notification-address-confirmations",
      method: "post",
      operationId: "createNotificationAddressConfirmation",
      pathParams: [],
      queryParams: [],
      hasBody: true
    },
    listActivities: {
      path: "/v1/activities",
      method: "get",
      operationId: "listActivities",
      pathParams: [],
      queryParams: ["limit", "cursor", "status", "type"],
      hasBody: false
    },
    getActivity: { path: "/v1/activities/{id}", method: "get", operationId: "getActivity", pathParams: ["id"], queryParams: [], hasBody: false },
    markActivitiesSeen: { path: "/v1/activities/seen", method: "post", operationId: "markActivitiesSeen", pathParams: [], queryParams: [], hasBody: true },
    listFavoriteProviders: {
      path: "/v1/favorite-providers",
      method: "get",
      operationId: "listFavoriteProviders",
      pathParams: [],
      queryParams: [],
      hasBody: false
    },
    createFavoriteProviders: {
      path: "/v1/favorite-providers",
      method: "post",
      operationId: "createFavoriteProviders",
      pathParams: [],
      queryParams: [],
      hasBody: true
    },
    deleteFavoriteProvider: {
      path: "/v1/favorite-providers/{providerAddress}",
      method: "delete",
      operationId: "deleteFavoriteProvider",
      pathParams: ["providerAddress"],
      queryParams: [],
      hasBody: false
    },
    getConfigureDraft: {
      path: "/v1/configure-drafts/{draftId}",
      method: "get",
      operationId: "getConfigureDraft",
      pathParams: ["draftId"],
      queryParams: [],
      hasBody: false
    },
    updateConfigureDraft: {
      path: "/v1/configure-drafts/{draftId}",
      method: "put",
      operationId: "updateConfigureDraft",
      pathParams: ["draftId"],
      queryParams: [],
      hasBody: true
    },
    deleteConfigureDraft: {
      path: "/v1/configure-drafts/{draftId}",
      method: "delete",
      operationId: "deleteConfigureDraft",
      pathParams: ["draftId"],
      queryParams: [],
      hasBody: false
    },
    listOrganizations: { path: "/v1/organizations", method: "get", operationId: "listOrganizations", pathParams: [], queryParams: [], hasBody: false },
    createOrganization: { path: "/v1/organizations", method: "post", operationId: "createOrganization", pathParams: [], queryParams: [], hasBody: true },
    updateOrganization: {
      path: "/v1/organizations/{id}",
      method: "patch",
      operationId: "updateOrganization",
      pathParams: ["id"],
      queryParams: [],
      hasBody: true
    },
    deleteOrganization: {
      path: "/v1/organizations/{id}",
      method: "delete",
      operationId: "deleteOrganization",
      pathParams: ["id"],
      queryParams: ["acknowledgedForfeitUsd"],
      hasBody: false
    },
    deleteOrganizationMembership: {
      path: "/v1/organizations/{id}/membership",
      method: "delete",
      operationId: "deleteOrganizationMembership",
      pathParams: ["id"],
      queryParams: [],
      hasBody: false
    },
    createOrganizationAdminAccessRequest: {
      path: "/v1/organizations/{id}/admin-access-requests",
      method: "post",
      operationId: "createOrganizationAdminAccessRequest",
      pathParams: ["id"],
      queryParams: [],
      hasBody: false
    },
    listProjects: { path: "/v1/projects", method: "get", operationId: "listProjects", pathParams: [], queryParams: [], hasBody: false },
    createProject: { path: "/v1/projects", method: "post", operationId: "createProject", pathParams: [], queryParams: [], hasBody: true },
    getProject: { path: "/v1/projects/{id}", method: "get", operationId: "getProject", pathParams: ["id"], queryParams: [], hasBody: false },
    updateProject: { path: "/v1/projects/{id}", method: "patch", operationId: "updateProject", pathParams: ["id"], queryParams: [], hasBody: true },
    deleteProject: { path: "/v1/projects/{id}", method: "delete", operationId: "deleteProject", pathParams: ["id"], queryParams: [], hasBody: false },
    listOrganizationActivities: {
      path: "/v1/organization-activities",
      method: "get",
      operationId: "listOrganizationActivities",
      pathParams: [],
      queryParams: ["projectId", "limit", "cursor"],
      hasBody: false
    },
    listOrganizationMembers: {
      path: "/v1/organization-members",
      method: "get",
      operationId: "listOrganizationMembers",
      pathParams: [],
      queryParams: [],
      hasBody: false
    },
    listOrganizationMemberProjectGrants: {
      path: "/v1/organization-members/{id}/project-grants",
      method: "get",
      operationId: "listOrganizationMemberProjectGrants",
      pathParams: ["id"],
      queryParams: [],
      hasBody: false
    },
    updateOrganizationMember: {
      path: "/v1/organization-members/{id}",
      method: "patch",
      operationId: "updateOrganizationMember",
      pathParams: ["id"],
      queryParams: [],
      hasBody: true
    },
    deleteOrganizationMember: {
      path: "/v1/organization-members/{id}",
      method: "delete",
      operationId: "deleteOrganizationMember",
      pathParams: ["id"],
      queryParams: [],
      hasBody: false
    },
    transferOrganizationOwnership: {
      path: "/v1/organization-members/{id}/ownership-transfer",
      method: "post",
      operationId: "transferOrganizationOwnership",
      pathParams: ["id"],
      queryParams: [],
      hasBody: false
    },
    listOrganizationInvitations: {
      path: "/v1/organization-invitations",
      method: "get",
      operationId: "listOrganizationInvitations",
      pathParams: [],
      queryParams: [],
      hasBody: false
    },
    createOrganizationInvitations: {
      path: "/v1/organization-invitations",
      method: "post",
      operationId: "createOrganizationInvitations",
      pathParams: [],
      queryParams: [],
      hasBody: true
    },
    resendOrganizationInvitation: {
      path: "/v1/organization-invitations/{id}/resend",
      method: "post",
      operationId: "resendOrganizationInvitation",
      pathParams: ["id"],
      queryParams: [],
      hasBody: false
    },
    createOrganizationInvitationLink: {
      path: "/v1/organization-invitations/{id}/link",
      method: "post",
      operationId: "createOrganizationInvitationLink",
      pathParams: ["id"],
      queryParams: [],
      hasBody: false
    },
    deleteOrganizationInvitation: {
      path: "/v1/organization-invitations/{id}",
      method: "delete",
      operationId: "deleteOrganizationInvitation",
      pathParams: ["id"],
      queryParams: [],
      hasBody: false
    },
    previewInvitation: { path: "/v1/invitations/preview", method: "post", operationId: "previewInvitation", pathParams: [], queryParams: [], hasBody: true },
    acceptInvitation: { path: "/v1/invitations/accept", method: "post", operationId: "acceptInvitation", pathParams: [], queryParams: [], hasBody: true },
    listReceivedInvitations: {
      path: "/v1/received-invitations",
      method: "get",
      operationId: "listReceivedInvitations",
      pathParams: [],
      queryParams: [],
      hasBody: false
    },
    acceptReceivedInvitation: {
      path: "/v1/received-invitations/{id}/accept",
      method: "post",
      operationId: "acceptReceivedInvitation",
      pathParams: ["id"],
      queryParams: [],
      hasBody: false
    },
    declineReceivedInvitation: {
      path: "/v1/received-invitations/{id}/decline",
      method: "post",
      operationId: "declineReceivedInvitation",
      pathParams: ["id"],
      queryParams: [],
      hasBody: false
    },
    listProjectMembers: {
      path: "/v1/projects/{id}/members",
      method: "get",
      operationId: "listProjectMembers",
      pathParams: ["id"],
      queryParams: [],
      hasBody: false
    },
    createProjectMember: { path: "/v1/project-members", method: "post", operationId: "createProjectMember", pathParams: [], queryParams: [], hasBody: true },
    updateProjectMember: {
      path: "/v1/project-members/{id}",
      method: "patch",
      operationId: "updateProjectMember",
      pathParams: ["id"],
      queryParams: [],
      hasBody: true
    },
    deleteProjectMember: {
      path: "/v1/project-members/{id}",
      method: "delete",
      operationId: "deleteProjectMember",
      pathParams: ["id"],
      queryParams: [],
      hasBody: false
    },
    listProjectSpend: {
      path: "/v1/project-spend",
      method: "get",
      operationId: "listProjectSpend",
      pathParams: [],
      queryParams: ["startDate", "endDate"],
      hasBody: false
    },
    listDeploymentSpend: {
      path: "/v1/deployment-spend",
      method: "get",
      operationId: "listDeploymentSpend",
      pathParams: [],
      queryParams: ["startDate", "endDate"],
      hasBody: false
    },
    listProjectBudgets: {
      path: "/v1/project-budgets",
      method: "get",
      operationId: "listProjectBudgets",
      pathParams: [],
      queryParams: ["projectId"],
      hasBody: false
    },
    createProjectBudget: { path: "/v1/project-budgets", method: "post", operationId: "createProjectBudget", pathParams: [], queryParams: [], hasBody: true },
    updateProjectBudget: {
      path: "/v1/project-budgets/{id}",
      method: "patch",
      operationId: "updateProjectBudget",
      pathParams: ["id"],
      queryParams: [],
      hasBody: true
    },
    deleteProjectBudget: {
      path: "/v1/project-budgets/{id}",
      method: "delete",
      operationId: "deleteProjectBudget",
      pathParams: ["id"],
      queryParams: [],
      hasBody: false
    },
    createAlert: { path: "/v1/alerts", method: "post", operationId: "createAlert", pathParams: [], queryParams: [], hasBody: true },
    listAlerts: {
      path: "/v1/alerts",
      method: "get",
      operationId: "listAlerts",
      pathParams: [],
      queryParams: ["limit", "page", "type", "dseq"],
      hasBody: false
    },
    getAlert: { path: "/v1/alerts/{id}", method: "get", operationId: "getAlert", pathParams: ["id"], queryParams: [], hasBody: false },
    updateAlert: { path: "/v1/alerts/{id}", method: "patch", operationId: "updateAlert", pathParams: ["id"], queryParams: [], hasBody: true },
    deleteAlert: { path: "/v1/alerts/{id}", method: "delete", operationId: "deleteAlert", pathParams: ["id"], queryParams: [], hasBody: false },
    createNotificationChannel: {
      path: "/v1/notification-channels",
      method: "post",
      operationId: "createNotificationChannel",
      pathParams: [],
      queryParams: [],
      hasBody: true
    },
    listNotificationChannels: {
      path: "/v1/notification-channels",
      method: "get",
      operationId: "listNotificationChannels",
      pathParams: [],
      queryParams: ["limit", "page"],
      hasBody: false
    },
    createDefaultNotificationChannel: {
      path: "/v1/notification-channels/default",
      method: "post",
      operationId: "createDefaultNotificationChannel",
      pathParams: [],
      queryParams: [],
      hasBody: true
    },
    getNotificationChannel: {
      path: "/v1/notification-channels/{id}",
      method: "get",
      operationId: "getNotificationChannel",
      pathParams: ["id"],
      queryParams: [],
      hasBody: false
    },
    updateNotificationChannel: {
      path: "/v1/notification-channels/{id}",
      method: "patch",
      operationId: "updateNotificationChannel",
      pathParams: ["id"],
      queryParams: [],
      hasBody: true
    },
    deleteNotificationChannel: {
      path: "/v1/notification-channels/{id}",
      method: "delete",
      operationId: "deleteNotificationChannel",
      pathParams: ["id"],
      queryParams: [],
      hasBody: false
    },
    createNotificationChannelConfirmationEmail: {
      path: "/v1/notification-channels/{id}/confirmation-emails",
      method: "post",
      operationId: "createNotificationChannelConfirmationEmail",
      pathParams: ["id"],
      queryParams: [],
      hasBody: true
    },
    upsertDeploymentAlert: {
      path: "/v1/deployment-alerts/{dseq}",
      method: "post",
      operationId: "upsertDeploymentAlert",
      pathParams: ["dseq"],
      queryParams: [],
      hasBody: true
    },
    listDeploymentAlerts: {
      path: "/v1/deployment-alerts/{dseq}",
      method: "get",
      operationId: "listDeploymentAlerts",
      pathParams: ["dseq"],
      queryParams: [],
      hasBody: false
    }
  },
  v2: {
    getDeploymentSetting: {
      path: "/v2/deployment-settings/{dseq}",
      method: "get",
      operationId: "getDeploymentSetting",
      pathParams: ["dseq"],
      queryParams: ["userId"],
      hasBody: false
    },
    updateDeploymentSetting: {
      path: "/v2/deployment-settings/{dseq}",
      method: "patch",
      operationId: "updateDeploymentSetting",
      pathParams: ["dseq"],
      queryParams: ["userId"],
      hasBody: true
    }
  }
} as const;

export type Operations = typeof operations;
